import { Component, OnInit } from '@angular/core';
import { LectionarySourceService, LectionarySource } from '../../services/lectionary-source.service';
import { MatDialogRef } from '@angular/material/dialog';
import { ReligionBranchServiceService, ReligionBranchSummary } from '../../services/religion-branch.service';

@Component({
  selector: 'app-lectionary-source-edit',
  templateUrl: './lectionary-source-edit.component.html',
  styleUrls: ['./lectionary-source-edit.component.css']
})
export class LectionarySourceEditComponent implements OnInit {

  public item: LectionarySource;
  public listsLoaded: boolean;
  public religionBranches: ReligionBranchSummary[];
  public title: string;

  constructor(
    private lectionarySourceSvc: LectionarySourceService,
    private religionBranchSvc: ReligionBranchServiceService,
    private dialog: MatDialogRef<LectionarySourceEditComponent>
  ) { }

  ngOnInit() {

    this.listsLoaded = false;


    var religionBranchPromise = this.religionBranchSvc.loadEntities().then(
      (data) => {
        this.religionBranches = data;
      }
    )

    Promise.all([religionBranchPromise]).then(
      (data) => {
        console.log("All promises are completed");
        this.listsLoaded = true;
      }
    );

  }

  public LoadItem(itemId: number) {

    if (itemId == null) {
      this.item = new LectionarySource();
      this.title = "Add New Lectionary Source";
    }
    else 
    {
      this.title = "Edit Lectionary Source";
      this.lectionarySourceSvc.getItem(itemId).then(
        (data: LectionarySource) => {
          this.item = data;
          this.listsLoaded = true;
          console.log(data);
       //   this.currentLocalizedData = this.item.Localized[0];
        }
      )
    }

  }


  private setModelValue(value: any, target: any) {

    if (target == null) {
      target = {
        Id: value
      };
    } else {
      target.Id = value;
    }

    return target;

  }

  public cancel() {
    this.dialog.close();
  }

  public save() {
    console.log(this.item);

    this.lectionarySourceSvc.save(this.item).then(
      (data) => {
        console.log(data);
        this.dialog.close(data);
      }
    ).catch(
      (err) => {
        console.log("error", err);
      }
    )

  }

  }


